import React, { useState } from 'react';
import Navbar from './../pages/Navbar';
import Footer from './../pages/Footer';

function Help() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://apiv2.chakran.in/api/HelpContacts/HelpContact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setResponseMessage("Your contact request has been submitted successfully. We will contact you soon...");
        setFormData({ name: "", email: "", number: "", message: "" });
      } else {
        setResponseMessage(data.message || "Failed to submit contact request.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setResponseMessage("An error occurred. Please try again later.");
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="card-header align-items-center px-3 px-md-5 text-center mt-4">
          <h2>Contact Us</h2>
        </div>
        <div className="content-wrapper">
          <div className="content">
            <form onSubmit={handleSubmit}>
              <div className="modal-body px-4">
                <div className="row mb-2">
                  {/* Name */}
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="emailid@gmail.com"
                        required
                      />
                    </div>
                  </div>

                  {/* Mobile No */}
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="number">Mobile No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="number"
                        name="number"
                        value={formData.number}
                        onChange={handleChange}
                        placeholder="Enter your mobile number"
                        required
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Enter your query"
                        rows="4"
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="modal-footer px-4">
                <button type="submit" className="btn btn-primary btn-pill">Contact US</button>
              </div>

              {/* Display response message */}
              {responseMessage && <p className="text-success mt-3">{responseMessage}</p>}
            </form>
          </div>
            <div className="row">
              <div className="offset-3 col-lg-6 col-xl-6">
                <div className="card card-default p-4">
                  <div className="media-body">
                    <h5 className="mt-0 mb-2 text-dark">Contact Us</h5>
                    <ul className="list-unstyled text-smoke text-smoke">
                        <li className="d-flex"><i className="mdi mdi-map mr-1"></i><span> Shop No.5, Shanti Nagar Dongari, S V Road, Near Canara Bank, Dahisar East, Mumbai - 400068</span></li>
                        <li className="d-flex"><i className="mdi mdi-email mr-1"></i><a href="mailto:support@chakran.in" className="text-decoration-none">support@chakran.in</a></li>
                        <li className="d-flex"><i className="mdi mdi-phone mr-1"></i><a href="tel:+919967318555" className="text-decoration-none">+91 9967318555</a></li>
                    </ul>
                  </div>
                </div>
              </div>     
             </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Help;


// import React from 'react';
// import Navbar from './../pages/Navbar';
// import Footer from './../pages/Footer';


// function Help() {
//   return (
//    <div>
//      <Navbar />
//         <>
//         <div className="card-header align-items-center px-3 px-md-5">
//             <h2>Contacts</h2>
//         </div>
//         <div className='container'>
//           <div className="content-wrapper">
//             <div className="content">
//               <div className="">
//                 <form>
//                   <div className="modal-body px-4">
//                     <div className="row mb-2">
//                       <div className="col-lg-4">
//                         <div className="form-group">
//                           <label htmlFor="firstName">Name</label>
//                           <input type="text" className="form-control" id="firstName" placeholder="Name"/>
//                         </div>
//                       </div>

//                       <div className="col-lg-4">
//                         <div className="form-group mb-4">
//                           <label htmlFor="email">Email</label>
//                           <input type="email" className="form-control" id="email" placeholder="emailid@gmail.com"/>
//                         </div>
//                       </div>

//                       <div className="col-lg-4">
//                         <div className="form-group mb-4">
//                           <label htmlFor="Birthday">Mobile No</label>
//                           <div className="input-group mb-3">
//                             <div className="input-group-prepend">
//                               <span className="input-group-text mdi mdi-phone" id="basic-addon1"></span>
//                             </div>
//                             <input type="text" className="form-control" data-mask="(999) 999-9999" autocomplete="off" maxlength="14" />
//                           </div>
//                         </div>
//                       </div>

//                       <div className="col-lg-12">
//                         <div className="form-group mb-4">
//                           <label htmlFor="event">Message</label>
//                           <textPath type="text" className="form-control" id="Message" aria-placeholder='Enter your query'/>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="modal-footer px-4">
//                     <button type="button" className="btn btn-smoke btn-pill" data-dismiss="modal">Cancel</button>
//                     <button type="button" className="btn btn-primary btn-pill">Contact</button>
//                   </div>
//                 </form>
//                 </div>
//                 <div className="py-5 py-md-6">
//                   <div className="row">
//                     <div className="col-lg-6 col-xl-4">
//                       <div className="card card-default p-4">
//                           <div className="media-body">
//                             <h5 className="mt-0 mb-2 text-dark">Emma Smith</h5>
//                             <ul className="list-unstyled text-smoke text-smoke">
//                               <li className="d-flex">
//                                 <i className="mdi mdi-map mr-1"></i>
//                                 <span>Nulla vel metus 15/178</span>
//                               </li>
//                               <li className="d-flex">
//                                 <i className="mdi mdi-email mr-1"></i>
//                                 <span>exmaple@email.com</span>
//                               </li>
//                               <li className="d-flex">
//                                 <i className="mdi mdi-phone mr-1"></i>
//                                 <span>(123) 888 777 632</span>
//                               </li>
//                             </ul>
//                           </div>
//                       </div>
//                     </div>
                
//                     <div className="col-lg-6 col-xl-4">
//                       <div className="card card-default p-4">
//                           <div className="media-body">
//                             <h5 className="mt-0 mb-2 text-dark">Emma Smith</h5>
//                             <ul className="list-unstyled text-smoke">
//                               <li className="d-flex">
//                                 <i className="mdi mdi-map mr-1"></i>
//                                 <span>Nulla vel metus 15/178</span>
//                               </li>
//                               <li className="d-flex">
//                                 <i className="mdi mdi-email mr-1"></i>
//                                 <span>exmaple@email.com</span>
//                               </li>
//                               <li className="d-flex">
//                                 <i className="mdi mdi-phone mr-1"></i>
//                                 <span>(123) 888 777 632</span>
//                               </li>
//                             </ul>
//                           </div>
//                       </div>
//                     </div>

//                     <div className="col-lg-6 col-xl-4">
//                       <div className="card card-default p-4">
//                           <div className="media-body">
//                             <h5 className="mt-0 mb-2 text-dark">Emma Smith</h5>
//                             <ul className="list-unstyled text-smoke">
//                               <li className="d-flex">
//                                 <i className="mdi mdi-map mr-1"></i>
//                                 <span>Nulla vel metus 15/178</span>
//                               </li>
//                               <li className="d-flex">
//                                 <i className="mdi mdi-email mr-1"></i>
//                                 <span>exmaple@email.com</span>
//                               </li>
//                               <li className="d-flex">
//                                 <i className="mdi mdi-phone mr-1"></i>
//                                 <span>(123) 888 777 632</span>
//                               </li>
//                             </ul>
//                           </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>  
//           </div>  
//      <Footer/>
//      </>
//   </div>
//   );
// }

// export default Help;
